module.exports = __webpack_public_path__ + "assets/img/icon_ok.99dd1d30.svg";